import React from "react";
import { useSelector } from "react-redux";
import { Box, Grid, Stack, Typography } from "@mui/material";

import BlockContainer from "../../components/Container/BlockContainer";
import { DEMO_REPORTS } from "../../components/SectionHealthReport";
import BaseImage from "../../components/BaseImage";

import IconPencil from "../../assets/images/icons/icon-pencil.svg"

const FamilyMemberProfileTab = () => {
  const auth = useSelector(state => state.auth)
  
  return (
    <Box>
      <BlockContainer
        sx={{
          mt: '24px'
        }}
      >
        <Stack spacing={'16px'}>
          <Box
            sx={{
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
            }}
          >
            <Box>
              <Typography
                variant="h4"
                color="primary.black"
              >
                Family member name's profile
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  borderTop: '1px solid #ABB7C0',
                  pt: '16px',
                  mt: '16px',
                }}
              >
                <BaseImage
                  sx={{
                    minWidth: '80px',
                    height: '80px',
                  }}
                  sximage={{
                    borderRadius: '50%'
                  }}
                  src={'//ssl.gstatic.com/accounts/ui/avatar_2x.png'}
                  alt='profile-avatar'
                />
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    flexGrow: 1,
                    ml: '16px'
                  }}
                >
                  <Typography variant="h3" color='primary.black'>
                    {`${auth?.firstName} ${auth?.lastName}`}
                  </Typography>
                  <Typography variant="body" color='primary.darkGray'>
                    {auth?.email}
                  </Typography>
                  <Typography
                    variant="body"
                    sx={{
                      width: '100%',
                      color: 'primary.darkGray',
                      backgroundColor: 'primary.lightGreen',
                      padding: '13px 12px 12px',
                      borderRadius: '5px',
                      mt: '10px'
                    }}
                  >
                    Sex assigned at birth: <strong>{auth?.sex}</strong>
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Typography
                variant="h4"
                color="primary.black"
              >
                Involved Family groups
              </Typography>
              <Box
                sx={{
                  borderTop: '1px solid #ABB7C0',
                  pt: '16px',
                  mt: '16px',
                }}
              >
                <Grid container spacing={'12px'}>
                  {DEMO_REPORTS.map((item => (
                    <Grid item xs={12} key={item.name}>
                      <Box
                        sx={{
                          borderRadius: '5px',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Box sx={{
                          width: '24px',
                          height: '24px',
                          backgroundColor: '#D9D9D9'
                        }}></Box>
                        <Typography
                          variant="body"
                          color="primary.black"
                          ml='16px'
                        >
                          {item.name}
                        </Typography>
                      </Box>
                    </Grid>
                  )))}
                </Grid>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Typography
                variant="h4"
                color="primary.black"
              >
                Reports
              </Typography>
              <Typography
                variant="body"
                color="primary.darkGray"
              >
                *Available to family members only
              </Typography>
              <Box
                sx={{
                  borderTop: '1px solid #ABB7C0',
                  pt: '16px',
                  mt: '16px',
                }}
              >
                <Grid container spacing={'16px'}>
                  {DEMO_REPORTS.map((item => (
                    <Grid item xs={12} md={6} key={item.name}>
                      <Box
                        sx={{
                          borderRadius: '8px',
                          padding: '8px 16px',
                          backgroundColor: 'background.default',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <BaseImage
                            sx={{
                              minWidth: '24px',
                              height: '24px',
                              mr: '16px'
                            }}
                            src={item.icon}
                            alt={item.name}
                          />
                        <Typography
                          variant="body"
                          color="primary.black"
                        >
                          {item.name}
                        </Typography>
                      </Box>
                    </Grid>
                  )))}
                </Grid>
              </Box>
            </Box>
          </Box>
        </Stack>
      </BlockContainer>
      <BlockContainer
        sx={{
          mt: '56px'
        }}
      >
        <Box
          sx={{
            mb: '24px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography
            variant="h2"
            color='primary.black'
          >
            Private information
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer'
            }}
          >
            <Typography
              variant="body"
              sx={{
                color: 'primary.darkGray',
                textDecoration: 'underline'
              }}
            >
              Edit
            </Typography>
            <BaseImage 
              src={IconPencil}
              sx={{
                minWidth: '24px',
                height: '24px',
                ml: '8px'
              }}
            />
          </Box>
        </Box>
        <Stack spacing={'16px'}>
          <Box
            sx={{
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
            }}
          >
            <Box>
              <Typography
                variant="h4"
                color="primary.black"
              >
                Your order history
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  borderTop: '1px solid #ABB7C0',
                  pt: '16px',
                  mt: '16px',
                }}
              >
                <Typography
                  variant="body"
                  sx={{
                    width: '100%',
                    color: 'primary.darkGray',
                    backgroundColor: 'primary.lightBlue',
                    padding: '13px 12px 12px',
                    borderRadius: '5px',
                  }}
                >
                  Available information
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Typography
                variant="h4"
                color="primary.black"
              >
                Your current medication
              </Typography>
              <Typography
                variant="body"
                color="primary.darkGray"
              >
                *Unavailable to family members without your permission
              </Typography>
              <Box
                sx={{
                  borderTop: '1px solid #ABB7C0',
                  pt: '16px',
                  mt: '16px',
                }}
              >
                <Grid container spacing={'8px'}>
                  {DEMO_REPORTS.map((item => (
                    <Grid item xs={12} key={item.name}>
                      <Box
                        sx={{
                          padding: '13px 12px 12px',
                          borderRadius: '5px',
                          backgroundColor: 'primary.lightBlue',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Typography
                          variant="h4"
                          color="primary.black"
                        >
                          {item.name}
                        </Typography>
                      </Box>
                    </Grid>
                  )))}
                </Grid>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0px 2px 10px 0px #5B87EF33',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Typography
                variant="h4"
                color="primary.black"
              >
                Reports
              </Typography>
              <Typography
                variant="body"
                color="primary.darkGray"
              >
                *Unavailable to family members without your permission
              </Typography>
              <Box
                sx={{
                  borderTop: '1px solid #ABB7C0',
                  pt: '16px',
                  mt: '16px',
                }}
              >
                <Grid container spacing={'8px'}>
                  {DEMO_REPORTS.map((item => (
                    <Grid item xs={12} key={item.name}>
                      <Box
                        sx={{
                          // padding: '13px 12px 12px',
                          borderRadius: '5px',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Box sx={{
                          width: '24px',
                          height: '24px',
                          backgroundColor: '#D9D9D9'
                        }}></Box>
                        <Typography
                          variant="h4"
                          color="primary.black"
                          ml='16px'
                        >
                          {item.name}
                        </Typography>
                      </Box>
                    </Grid>
                  )))}
                </Grid>
              </Box>
            </Box>
          </Box>
        </Stack>
      </BlockContainer>
    </Box>
  );
};

export default FamilyMemberProfileTab;
